export default __webpack_public_path__ + "static/instagram-logo-cb48bd40ef751fe7bf8248e1b150fa24.png";